export const CHART_OPTIONS = {
  colors:['#0062CC','#00B900','#FF9300','#EBC147','#D73C74','#8048C8','#6D84C9','#34A0D5'],
  chartType:[
      { value:'line', label:'线'},
      { value:'bar', label:'柱状图'},
  ],
  unit:[],
  lineTypes:[
      { value:'solid', label:'solid'},
      { value:'dashed', label:'dashed'},
      { value:'dotted', label:'dotted'},        
  ],
  align:[
    { value:'left', label:'居左'},
    { value:'center', label:'居中'},
    { value:'right', label:'居右'}
  ],
  hAlign:[
    { value:'top', label:'顶部'},
    { value:'middle', label:'居中'},
    { value:'bottom', label:'底部'}
  ],  
  sampling:[
      { value:'lttb', label:'lttb'},     
  ],
  fontWeight:[
      { value:'normal', label:'normal'},
      { value:'bold', label:'bold'},
      { value:'bolder', label:'bolder'},     
  ],
  position:[
      { value:'left', label:'Left'}, 
      { value:'right', label:'Right'},    
  ],
  xAxisType:[
      { value:'category', label:'Category'}, 
      { value:'time', label:'Time'},    
  ],
  dtFormat:[
      { value:'yyyy/MM/dd HH:mm:ss', label:'yyyy/MM/dd HH:mm:ss'}, 
      { value:'yyyy/MM/dd HH:mm', label:'yyyy/MM/dd HH:mm'},
      { value:'yyyy/MM', label:'yyyy/MM'},
      { value:'MM/dd HH:mm', label:'MM/dd HH:mm'},
      { value:'yyyy/MM/dd', label:'yyyy/MM/dd'}, 
      { value:'HH:mm', label:'HH:mm'}, 
      { value:'HH:mm:ss', label:'HH:mm:ss'},   
  ], 
  xAxisMode:[
      { value:'time', label:'Time'}, 
      // { value:'series', label:'Series'},    
  ], 
  valueType:[
      { value:'first', label:'First'},
      { value:'last', label:'Last'},
      { value:'sum', label:'Sum'}, 
      { value:'avg', label:'Avg'}, 
      { value:'min', label:'Min'},
      { value:'max', label:'Max'},
      { value:'count', label:'Count'},   
  ],
  visualMapOrient: [
      { value:'horizontal', label:'水平'},  
      { value:'vertical', label:'垂直'},
  ],
  legendPosition:[
    { value:'bottom', label:'下'},
    { value:'top', label:'上'},
    { value:'left', label:'左'},
    { value:'right', label:'右'},
    { value:'leftTop', label:'左上'},
    { value:'leftBottom', label:'左下'},
    { value:'rightTop', label:'右上'},
    { value:'rightBottom', label:'右下'}
  ],
  pointSymbol: [
    { value:'pin', label:'pin'},  
    { value:'circle', label:'circle'},
    { value:'rect', label:'rect'},
    { value:'roundRect', label:'roundRect'},
    { value:'diamond', label:'diamond'},
    { value:'arrow', label:'arrow'},
    { value:'triangle', label:'triangle'},
    { value:'none', label:'none'},
  ],
  markLineType: [
    { value:'min', label:'最小值'},  
    { value:'max', label:'最大值'},
    { value:'average', label:'平均值'},
    { value:'median', label:'中位数'},
    { value:'y', label:'yAxis'},
  ],    
}

export const TABLE_OPTIONS = {
    dataType:[
        { value:'string', label:'字符串'},
        { value:'number', label:'数字'},
        { value:'datetime', label:'日期'},
        // { value:'hidden', label:'隐藏'},
    ],
    operator:[
        { value:'==', label:'等于'},
        { value:'>', label:'大于'},
        { value:'<', label:'小于'},
        { value:'>=', label:'大于等于'},
        { value:'<=', label:'小于等于'}
    ],
}

export const COMMON_OPTIONS = {
  colorSeries:[
    { name:'1', colors:['#0062CC','#00B900','#FF9300','#EBC147','#F7567C','#D73C74','#8048C8','#6D84C9','#34A0D5','#86A800']},
    { name:'2', colors:['#008CD6','#7D2ED7','#FF3CC7','#00CED1','#F9C80E','#00CC66','#3D3BF3','#B68E55','#9ACD32','#F7567C']},
  ],
  colors:['#323233','#fafafa','#787878','#C8C8C8','#008CD6','#0062CC','#00B900','#FF9300','#EBC147','#F7567C','#D73C74','#8048C8','#6D84C9','#34A0D5','#86A800','#02AC6F','#DF001A'],
  dataSource:[
    { value:'apm', label:'IoT时序数据源'},       
    { value:'simulate', label:'模拟数据源'},
    { value:'dw', label:'数据仓湖'}
  ],
  optionSource:[
    { value:'manual', label:'手动添加'},          
    { value:'simulate', label:'模拟数据源'},
    { value:'dw', label:'数据仓湖'}
  ],      
  inputType:[
      { value:'datetime', label:'日期'},
      { value:'input', label:'输入框'},
      { value:'selector', label:'选择框'},
  ],
  dtTypes:[
      // { value:'Custom', label:'自定义'},
      { value:'ThisDay', label:'当天'},  
      { value:'ThisWeek', label:'本周'},
      { value:'ThisMonth', label:'当月'},        
      { value:'LastHour', label:'过去1小时'},
      { value:'LastDay', label:'过去24小时'},
      { value:'Last3Day', label:'过去三天'},
      { value:'Last7Day', label:'过去一周'},
      { value:'Last30Day', label:'过去一月'},
      { value:'ThisYear', label:'本年度'},
  ],
  dataType:[
    { value:'-', label:'-'},
    { value:'string', label:'字符串'},
    { value:'number', label:'数字'},
    { value:'datetime', label:'日期'},
  ], 
  numberType:[
    { value:'-', label:'-'},
    { value:'thousands', label:'千分位分隔'},
    { value:'percent', label:'百分比'},
  ],
  numberScale:[
    { value:'-', label:'-'},
    { value:'0', label:'0'},
    { value:'1', label:'1'},
    { value:'2', label:'2'},
  ],               
  filterOperator:[
      { value:'==', label:'等于'},
      { value:'!=', label:'不等于'},
      { value:'in', label:'包含'},
      { value:'notIn', label:'不包含'},
      { value:'>', label:'大于'},
      { value:'>=', label:'大于等于'},
      { value:'<', label:'小于'},
      { value:'<=', label:'小于等于'},
      { value:'null', label:'空值'},
      { value:'notNull', label:'非空值'},
      { value:'empty', label:'空字符串'},
      { value:'notEmpty', label:'非空字符串'}
  ],
  sortType: [
    { value:'none', label:'默认'},
    { value:'desc', label:'从大到小'},
    { value:'asc', label:'从小到大'},
  ]            
}

export const SELECTOR_OPTIONS = {
  cmptTypes:[
      { value:'input', label:'输入框'},
      { value:'selector', label:'选择框'},  
      { value:'datetime', label:'日期'},
      { value:'node', label:'设备筛选'}
  ],
  dateCategory:[
    { value:'datetime', label:'日期'},
    { value:'range', label:'时间范围'},
    { value:'relative', label:'相对时间'},
  ],
  dateType:[
      { value:'date', label:'日', parent:'datetime'},
      { value:'month', label:'月', parent:'datetime'},
      { value:'year', label:'年', parent:'datetime'},
      { value:'datetime', label:'日期时间', parent:'datetime'},

      { value:'daterange', label:'日期范围', parent:'range'},
      { value:'datetimerange', label:'日期时间范围', parent:'range'},
      // { value:'week', label:'周', parent:'range'},        
      { value:'monthrange', label:'月范围', parent:'range'},
      { value:'yearrange', label:'年范围', parent:'range'},        
  ],
  relativeDateType: [
      { value:'ThisDay', label:'当天'},  
      { value:'ThisWeek', label:'本周'},
      { value:'ThisMonth', label:'当月'},        
      { value:'LastHour', label:'过去1小时'},
      { value:'LastDay', label:'过去24小时'},
      { value:'Last3Day', label:'过去三天'},
      { value:'Last7Day', label:'过去一周'},
      { value:'Last30Day', label:'过去一月'},
      { value:'ThisYear', label:'本年度'},
  ]
}

export const WIDGETS = [
  {
    id: 'basic',
    category: '基础组件',
    panels: [
      {
        type:'Title',
        category:'Widget',
        path:'Basic/Title',
        label:'标题',
        desc: '显示看板标题与数据更新时间',
        noRefresh: true,
        grid: {
          w: 24,
          h: 1,
          minW: 2,
        },
        style:{
          background: {
            color: 'transparent',
            padding: 0,
          },
          content:{
            padding:0,
            paddingTop:0,
            paddingRight:0,
            paddingBottom:0,
            paddingLeft:0,
          },
          margin: {
            marginTop: '0px',
            marginRight: '4px',
            marginBottom: '0px',
            marginLeft: '4px',
          }
        },
        props:{
          dataPanel:false,
          dataSource:false,
        },
        img:'',
        imgName:'Title.svg'
      },
      {
        type:'Tab',
        category:'Widget',
        path:'Basic/Tab',
        label:'标签页',
        desc: 'Tab标签页',
        grid: {
          w: 12,
          h: 16,
          minW: 3,
        },
        style:{
          title: {
            show: false
          },
          background: {
            color: '#EDEDED',
            padding: 0,
            show: true,
          },
          content:{
            padding:0,
            paddingTop:0,
            paddingRight:0,
            paddingBottom:0,
            paddingLeft:0,
          }
        },
        props:{
          dataPanel:false,
          dataSource:false,
        },            
        img:'',
        imgName:'Tab.svg'        
      },
      {
        type:'Container',
        category:'Widget',
        path:'Basic/Container',
        label:'容器',
        desc: '组件的容器，用于对组件进行布局和分组',
        grid: {
          w: 12,
          h: 16,
          minW: 3,
        },
        style:{
          title: {
            show: false
          },
          background: {
            color: 'transparent',
            padding: 0,
          },
          content:{
            padding:0,
            paddingTop:0,
            paddingRight:0,
            paddingBottom:0,
            paddingLeft:0,
          }
        },
        props:{
          dataPanel:false,
          dataSource:false,
        },            
        img:'',
        imgName:'Container.svg'        
      },
      {
        type:'Text',
        category:'Widget',
        path:'Basic/InputText',
        label:'输入框',
        desc: '文本输入',
        grid: {
          w: 4,
          h: 6,
          minW: 2,
        },
        props:{
          dataPanel:false,
          dataSource:false,
        },
        img:'',
        imgName:'Text.svg'        
      },
      {
        type:'ParameterCard',
        category:'Widget',
        path:'Basic/ParameterCard',
        label:'属性卡',
        desc: '属性卡',
        grid: {
          w: 4,
          h: 6,
          minW: 2,
        },
        props:{
          direction: false,
          dim:2,
        },
        img:'',
        imgName:'ParameterCard.svg'           
      },        
      {
        type:'KPIIndicator',
        category:'Widget',
        path:'Basic/KPIIndicator',
        label:'KPI指标',
        desc: '指标数据',
        grid: {
          w: 4,
          h: 4,
          minW: 1,
        },
        props:{
          direction: false
        },
        img:'',
        imgName:'KPIIndicator.svg'        
      },
      {
        type:'LineChart',
        category:'Chart',
        path:'Chart/LineChart',
        label:'柱线组合图',
        desc: '柱状/折线图',
        grid: {
          w: 10,
          h: 14,
        },
        props:{
          direction: false,
          dim:2,
        },
        img:'',
        imgName:'LineChart.svg'        
      },
      { 
        type:'Table', 
        category:'Chart',
        path:'Basic/Table', 
        label:'明细表', desc: '明细表', 
        props:{
          calc:false,
          direction: false,
          dim:0,
        },
        img:'',
        imgName:'Table.svg'        
      },
      { 
        type:'PieChart', 
        category:'Chart',
        path:'Chart/PieChart', 
        label:'饼图', 
        desc:'显示各部分在整体中的占比', 
        props:{
          direction: true,
          dim:2,
        },
        img:'',
        imgName:'PieChart.svg'        
      },
      {
        type:'WindRoseChart',
        category:'Chart',
        path:'Chart/WindRoseChart',
        label:'气象玫瑰图',
        desc: '气象玫瑰图',
        grid: {
          w: 10,
          h: 14,
        },
        props:{
          calc:false,
          direction: false,
          dim:0,
        },
        img:'',
        imgName:'WindRoseChart.svg'        
      },
      {
        type:'Video',
        category:'Widget',
        path:'Basic/Video',
        label:'Video',
        desc: '显示实时、历史监控画面',
        noRefresh: true,
        grid: {
          w: 8,
          h: 12,
        },
        style:{
          content:{
            padding:0,
            paddingTop:0,
            paddingRight:0,
            paddingBottom:0,
            paddingLeft:0,
          }
        },
        props:{
          dataPanel:false,
          dataSource:false,
        },
        img:'',
        imgName:'Video.svg'        
      },
      {
        type:'EzvizVideo',
        category:'Widget',
        path:'Basic/EzvizVideo',
        label:'EzvizVideo',
        desc: '萤石云视频',
        noRefresh: true,
        grid: {
          w: 8,
          h: 12,
        },
        style:{
          content:{
            padding:0,
            paddingTop:0,
            paddingRight:0,
            paddingBottom:0,
            paddingLeft:0,
          }
        },
        props:{
          dataPanel:false,
          dataSource:false,
        },
        img:'',
        imgName:'EzvizVideo.svg'        
      },
      {
        type:'Html',
        category:'Widget',
        path:'Basic/Html',
        label:'Html',
        desc:'HTML代码',
        props:{
          dataSource:false,
        },
        img:'',
        imgName:'Html.svg'        
      },
      {
        type:'IFrame',
        category:'Widget',
        path:'Basic/IFrame',
        label:'URL嵌入',
        desc:'嵌入并预览web页面',
        props:{
          dataSource:false,
        },
        img:'',
        imgName:'IFrame.svg'        
      },
      { 
        type:'RichText', 
        category:'Widget',
        path:'Basic/RichText', 
        label:'富文本', 
        desc: '富文本数据',
        props:{
          direction: false
          // dim:0,
        },          
        img:'',
        imgName:'RichText.svg'        
      },        
      {
        type:'Image',
        category:'Widget',
        path:'Basic/Image',
        label:'图片',
        desc:'上传并展示图片',
        grid: {
          w: 4,
          h: 8,
          minW: 2,
        },
        style: {
          title: {
            show: false
          },
          content:{
            padding:0,
            paddingTop:0,
            paddingRight:0,
            paddingBottom:0,
            paddingLeft:0,
          },
        },
        props:{
          dataPanel:false,
        },
        img:'',
        imgName:'Image.svg'        
      },
      // { 
      //   type:'RichText', 
      //   category:'Widget',
      //   path:'Basic/RichText', 
      //   label:'富文本', 
      //   desc: '富文本数据',
      //   img:'',
      //   imgName:'RichText.svg'        
      // },
      // { type:'Descriptions', category:'Basic',path:'Basic/Descriptions', label:'描述列表', desc: '描述列表', img: ''},
      {
        type:'Liquidfill',
        category:'Chart',
        path:'Chart/Liquidfill',
        label:'水球图',
        desc: '水球图',
        grid: {
          w: 10,
          h: 14,
        },
        props:{
          calc:false,
          direction: false,
          dim:0,
        },
        img:'',
        imgName:'Liquidfill.svg'        
      },
      {
        type:'ProgressBar',
        category:'Chart',
        path:'Chart/ProgressBar',
        label:'进度条',
        desc: '进度条',
        grid: {
          w: 10,
          h: 8,
        },
        props:{
          // calc:false,
          direction: false,
          dim:0,
        },
        img:'',
        imgName:'ProgressBar.svg'        
      },
      {
        type:'ProgressRing',
        category:'Chart',
        path:'Chart/ProgressRing',
        label:'环状进度条',
        desc: '环状进度条',
        grid: {
          w: 10,
          h: 14,
        },
        props:{
          calc:false,
          direction: false,
          dim:0,
        },
        img:'',
        imgName:'ProgressRing.svg'        
      },
      {
        type:'RadarChart',
        category:'Chart',
        path:'Chart/RadarChart',
        label:'雷达图',
        desc: '雷达图',

        grid: {
          w: 10,
          h: 14,
        },
        props:{
          // calc:false,
          direction: true,
          dim:1,
        },
        img:'',
        imgName:'RadarChart.svg'        
      },
      {
        type:'TreemapChart',
        category:'Chart',
        path:'Chart/TreemapChart',
        label:'矩形树图',
        desc: '矩形树图',

        grid: {
          w: 10,
          h: 14,
        },
        props:{
          // calc:true,
          direction: false,
          multiDim:true,
          dim:1,
        },
        img:'',
        imgName:'TreemapChart.svg'        
      },
      {
        type:'HeatMap',
        category:'Chart',
        path:'Chart/HeatMap',
        label:'热力图',
        desc: '热力图',
        grid: {
          w: 10,
          h: 14,
        },
        props:{
          calc:false,
          direction: false,
          dim:0,
        },
        img:'',
        imgName:'HeatMap.svg'        
      },
      {
        type:'Gauge',
        category:'Chart',
        path:'Chart/Gauge',
        label:'仪表盘',
        desc: '仪表盘',
        grid: {
          w: 10,
          h: 14,
        },
        props:{
          calc:true,
          direction: false,
          dim:1,
        },
        img:'',
        imgName:'Gauge.svg'        
      },
      {
        type:'StandardGauge',
        category:'Chart',
        path:'Chart/StandardGauge',
        label:'标准仪表盘',
        desc: '标准仪表盘',
        grid: {
          w: 10,
          h: 14,
        },
        props:{
          calc:true,
          direction: false,
          dim:1,
        },
        img:'',
        imgName:'StandardGauge.svg'        
      }         
    ]
  },
  {
    id: 'function',
    category: '功能组件',
    panels: [
      {
        type:'TimeLineChart',
        category:'Chart',
        path:'Widget/TimeLineChart',
        label:'设备运行状态切片',
        desc: '设备运行状态时间切片图',
        style:{
          content:{
            padding:0,
            paddingTop:0,
            paddingRight:0,
            paddingBottom:0,
            paddingLeft:0,
          }
        },
        grid: {
          w: 24,
          h: 5,
          minW: 12,
        },
        props:{
          calc:false,
          direction: false,
          dim:0,
          filter:false
        },
        img:'',
        imgName:'TimeLineChart.png'        
      },
      // { type:'OEEAvailability', category:'Widget', label:'OEE实时监控', desc: '设备OEE数据实时监控', img:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABBCAYAAAEF5dIZAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFxEAABcRAcom8z8AAA9sSURBVGhD7VtpcBTHFV4O4xiT2FUhJBWHYDuVFMbBroArlQOXbcAkOC4DBTH+QVIEV4whIY5FjBLJ4rRjYXNESOYKIkIgYskGxKUD3ZcloRvd5+pY3dKudrX3oS/znjLrXe1od7WsMK5iS1/NaKa7583X771+/bpHZjab4QkTL5TSmwKVWYWE/gR067tdC6mNatgsNvsNq8WKLl2XcyGVRcXHz6KPoywvjc9fq3jNuVCHsYOPjpiRNIOPTjI9X/i8/Xx73Xb7uVMhQnpvOhrVjU7XZPDi59KSFCZeSGlWokpbxXC8bi/017q/Ot3QWXX2c3shq9mK8NB9KEiNR/LVi7CZv2DfXqhEWWK/SBgwDNjP7YXa9G3cX3ROrcquyVwLEWAFDssPcyHH6/4j0xt4bIjEM5lNMJqMkvdFSDbUpmvDgzcexIhlxOk6vTsRc6D5gNN1gktDucpcJPQkOF0bC5VRhSdynnC65tIQ9bzYNYVJ5xC45yD27X2PCf30cjpfhwWYljTNqZ5LQ+3advys4GewmC1O1x3xeNbjKFYWO10bl+yf5P0EO+p3IFQeiqD6IMxJm4P7ku9DSGOIZHmZxWKBPzCuRBPFV6wh6matUQuNUcPnUmVESDZE7lmWKGMtll2RYer1qZAlCOdXZU6u2xEuDVFB0pMaTY3TdUKXvgtxPXGAzVU6l4YadY3YWrnV6Zoj9jftx2vlo2ODI5waItPoNn0xHI2HbGU2G7DjNaeGyBjFhmwjNhgF+wqPjMPeDyNw6Ua+8N8oP8c7jiO+M95ej+DUkNak5Vejc9LWvmETPty3E2cO70Zk7FXklFbzvUfSH8HJ1pP2egSnhkwmE0o1pU4FpEA96ej6+ZrjPwStTYtr3decrjmCeszR64twaYi6f3rydCh0CqfrhCZNE/Y075F0uy4NEcjFvlT8Er6b/l2sLlmNE20nkDqQii3VW2AwG1zKEyQbEkGOnyKV423HJe87wn/+iJ2xH35uX+3LwD2BPGHCAtHwS47oStcVPJb5GFIGUyC7LuOglwzQYDNgatJU1KprOYRxN1xLwWuByPbWlqyFeUSoJAwKB+UHEVIfggH9aIBImk3elf6/3H0ZP879MVaVrMLhtsNYnLfY4wgkwiuBDrcc5pGo1dCKqPYol/hyPJCAjZpGrK9Yz/UTexM9MuZWIGpwW/U27orVxatdxgxvQf70m6nfxP037sfFrotuhXIrkMasgezy6HjtLSvjwWYdHf+X3VyGQf2gZBmCW4EKlYUcMEy5PMWFHUV5Mjuy8LPXcPFMGA4c/Q/KU84hK+MGYs6dRc7NW7Bav3gJGkzeqHoDa0vXMkuObTnCrUA0oyGBpiZMdQk8bLYRfuCIMKKPjIwwbALMJkHBreS+TU4CERRGBYqGitCsaXa67gi3ApFlrChcwQr5bv2744ZWnkC6GCYPw7B1GIH1gW7bcSsQgcx9ScESfCvtWxgyD6Fb5zlocgQpML1QnioP0Z3RHg3Do0Aiho3DmJ8zn+egpORdxi706fv4bQnEAik+PZAc4rrSdewmyGme7DgJtUEt2e5YeC2QCHqg3qTHd9K+g93Nu7EgbwHWla/D0qKleLX8VawqXYUf5fwIpxSncKHzwoS7ecICTTb8Fsf463f3MSR18cvEPYE84Z5AnuCzQDQk0MSTjgaTAUOGIeiMOh5qPAVh7jBhgWjAJQFWFq5EUn8SZibPxJ6mPRxf/77y91hevBwri1byHN+XgG5CAtEwsCh3EY60HRkdMsrW4Zn8Z7ClZgu+n/Z9nO86z+lFOj6a+SieK3xuwoGd1wK1aduw4dYGhLWF8YDZoGtARl8GjGYjD6xijjOzPxNyvZwHYLVFzSN9qbLU6270SiCVQYX4vngWJEoRhSpVldsHECvDpmE8d/M5zE6bDa1V65KdHA8eBSKdmZIwBSuLV3Ky1lOq2BHUxdXaao6lv532ba90yq1A1OCF7gvoN/fj4dSHOcsnVc4daL4W0hCCck051hSv8S1D6AgO8pOmoGW4RfK+NyhVlXI7S28u5eBNqowItwJVDlVCaVF6FXq6A/krSvPtaNiBXXW7JMuIGFcg6q4XC1/kN/tN0W9clVjoCjpSl0gdx+KdmnfwWNZj2F673a0rGFcgEkBhUKDf1M9JOMd7LdWlOHAsFjajGiEhIdALk8C9u95F54Aa4WH/gn5YjcqWHqc6tFYQ3BiMZYXLJHO5IsYViLqIzJz8SWpvqvM94RcQfBDXo8OhN5oQ8LdA9GpM+PveMJyJikbYv8LR3tkrvNQXdSixvKp4FX5b8lu33e+WIY1Fw0uY8mG50z2ddhh/3BaCopRPUVtfh08uXEJ+eS2OfZqJqs+TkXQhBldiz7LgYp3qIcH8BSf5YNKDvjFEOvRUzlPM0ts1bzvdIz2hmapF8NCUBbZY6DrNVC0ChAGXZqzCPcc6PfoedBo7ca7rnN2rS2FcgQh1mjpecKJc0O1YGQ0tT+Y8yQxtKNvg1su7FYjeinSIZq3jWY830Jl0KBwqRIWmAvVD9ZJlRLgViLxq8VAxYntiMTdjrk8sETtx3XHc9RSi3Lan7tf3c8LqWPsxxHTGsG5JlZMC6crO+p28mker82PXi6XgUSBCr76Xgy96y2pNNadbpMo5gph4s/JNznh8Lflr+EvVX9zqjgivBCJW6E3zh/KxIGcBZ0NKVCX8AOpGOhIbYrIhqy8LH7Z8iKfznsaslFlQmpRuLcsRXglEIF2gsY26j+inIwk4O2U2WnWtWJyzGPmqfHvqhY4UBx1qOjShbvZaIBFkbecV57n7+sx9fCTnSQIOWYZ47Osz9eGV4legNCgnbJ0TFoggdpVCq8BJ+UlOZAXUBKBd1w65Rs73iVGpup7gk0CTCb+tT/kLd19+6P/Hu+Z31+nQ3YZ7BHnAPYI84B5BHnCPIA/40gkSoxSK38Rohc5FjC1/p3HHCCIixKibtvs0qZs49XCl5wpWFa3CT/N+imhFNHpNvXix6EWO2inc6zf0I70vHYUDhfZUGZM5wTSqr5hUgjjGFf5ov/LR1qOo19bzEiMF3hT9fyT/CN3GbszJmMP/BzUGQW6Qcy6Z/t/dtJvTvE9kP8F1lhUv44B9X+M+vFX1FgoHC0fTv5NI1qQQRKTQWn+voRe5qlzMTp/Ns5KFuQtZQ0JbQjlXMD97PsrV5djfsh+bKzYjvjsenfpORLREIKgmiKfvJ9pPYFriNDyS8Qh6jD3Y17yPyZMlyRDeFs4zm9CmUJQpy9ymd3yFXwmiGRHtvt9QsYEJobT0+83vY9A8yAvV8zLm4UTrCU7AUlkC9b5ofgRqx/FcnAQTaIWe6i+/uRyZg5nIUeXgobSH+FmU/k7oTWAT9nZy7A38QhBNWiivv6VqCzZWbuRt9yT8D7N/iPuT70dYS5j9JcUXvx1QO7QOFd0ejYU5CxHZEcmdsLVmK6YkTsELBS/wNNVTwscb3DZB5DBpe0NsVywW5C7gxRDyF78s+CXkWkFI4WV8nUt7ApFN7af0pWBOquDHBE1aXrQcZZoyDJgGeBAQy42t6y1uiyCy+fT+dHwv/Xu82e10x2nemEKbU1uHW1l4qXr+hthJHfoO9m+PZz4+auICKAFCmuQrST4TRA8kn5A+kI5ttdvwaLYw8ggCLclfwrsF/ekHvAHJQ9hctRnry9ezj9JYNWg3tLMm3dGMEAlCDwypC8HMlJlYVrQMOxt3Insw235/bJ07AX6uxYyNtzZieuL00XDiqgzP5D3DPsuXcMAnguhBtBB/quMUAmoDeAH2B1k/4L2n7szKahuhFIvg1Ee3xtPiyMiIFXq9HtaREYF0C2/tM+h1MFuFSNpG0bWF79OCCQ0GvNVPqCvVPoFkq9fUI3kgGY36Rl5P01q06NH13DmCyKarhqp4wy19sPNy6cv4w60/8Hq8tGnRapEVDZXliDt1CH8K/IjcFyqzL+Mfew+hoakJB/YEIybuEkL/GYrCWw3478fv44OIaJyPicHneXk4FnEKWWnXEBlzBUKQIPidsc8YBXVQmaoMD6c8zLEWadC0K9NwqPkQIPSPVB138IkgIqFB04Df3fod3qx+EwF1AdjVuIs3bLqbPxEprSWJ2B4iCCv8rp4Jw5HoqzAYTbgUFYa3t+/ARxH/QZ/GhPIbZxH0wSmYbWZ0tzXg7L+P4t+R0ThzOhKnomLQ0N4rvLBrZ5BstPKxu3E3+8bAhkDsadyDAmWBT8O+TwQRCbS/8/XK1/Hzgp9jXtY8zLoxC0eaj4xrYvSryE5E0DsB2Lr1zzh87Bx6BgcQe+ZjBAe/i8jYJEF+G3Kuf4JdwUHYHxGJAZ0widUN4Fp8POTdg+hrqxY06QjOX0xAn0onmKCrydDz69R1WFG0AnMz5+IbKd/A15O/jjiF9GdDnuCzk6YlQVprouF9c/VmnFacRqWmku18sp2049L2WJCfeq/hPfzq5q8Q1BCET7o/QZm6jMMAX+TyiSACb5XQd+OA/ACevfksb0yhYT6gOuCOxT9jQealMWkQ1RmFFcUreF2ORrKDTb4vWPtMEPUGPfSI/AjPvrdWb0WJugTNumZOT5CGTVYELQWS5ZziHB5IfAAPpT6ETZWbkNifCIVeIVneW/hMkAi2+eE6rC5djZk3Zo5GsMIk9YOmD9hXQSgiVc9fIK2hNXKaxNZqazk9srZsLc/4aXsCfVDpbuDwhNsmiEAk5Q/m49dFv0aGMoM/BKKRjdIU60rW8Z54cpDkH6Tq+wIihrSUNIQ2TM5InsGkkKlTGsRkMd0WMSL8QhCBTU4gIa4rblSTBNtf9PkiNOma8FnPZ7yLIUIewVlBItQX86N6lDXQmXWcbJueMB3Tk6bzXgD6WIq+b95UsYlXvf1BDsFvBImgnqUvUZuHmzk5Rl9ZktnRp2VnOs+wCVAC7encp5HWn8YxS81QDTq1nTy3U5vUbDIqvYo/FUrrTUN4Szja9e3s5yjwo6i9crgSKQMpmHFjBqYmTkVwXTCTRyRKyeUr/E6QCNYo4a9eXY/AmkBc7r2MOm0dZwaJsJeKXuINF2sq1vBL/6LgF7wfYsXNFfxd1lu1b6FF38LROmkjmSxtVKR8NUXI9JkvBX+UfBuxjvhNY8Zi0ghyBMVGZFJkXrR792jLUWQNZPEoMzdtLhNGsdSgZZC31xBhFICS2RAx5FfIvxHZZD6kaaQpk0WKI+4IQeOBXpBelHwXaQERKf7PTl3QQipD96Tq3wl8qQR9FXDXbTe52373CHL7A/4HVCqPCu5TT3MAAAAASUVORK5CYII='},
    ]
  },
  {
    id: 'query',
    category: '筛选器',
    panels: [
      {
        type:'Query',
        category:'Common',
        path:'Common/Query',
        label:'查询组件',
        desc: '查询组件',
        noRefresh: true,
        style:{
          title: {
            show: false
          },
          background: {
            color: 'transparent',
            padding: 0,
          },
          content:{
            padding:0,
            paddingTop:0,
            paddingRight:0,
            paddingBottom:0,
            paddingLeft:0,
          },
          margin: {
            marginTop: '0px',
            marginRight: '4px',
            marginBottom: '0px',
            marginLeft: '4px',
          }
        },
        grid: {
          w: 24,
          h: 1,
          minW: 12,
        },
        img:'',
        imgName:'Query.svg' 
      },
    ]
  },      
]

export const PANEL_TEMPLATE = {
    id: null as any,
    type:'',
    category:'',
    gridPos:{
        w: 8,
        h: 6,
        IDBTransaction, // 便于后续查找
        content: ''
    },
    data:{
        // datasource: "apm",
        // targets:[]
    },
    custom:{

    },
    query:{
        time:{
            enable:true,
            timeType:'Relative',
            dtType:'Last7Day',
            dtRange:[],
            map:{
               startTs:'startTs',
               endTs:'endTs',
            }
        },
    },
    linkage:{
        enable:true,
        list:[]
    },
    style:{
        title:{
            show:true,
            label:'',
            color:'#323232',
            fontSize:18, 
            fontWeight:'bold', 
            align:'left',
            showBorder:false,  
        },
        border:{
                show: false,
                color:'#c8c8c8',
                style: 'solid',
                width: 0,
                radius: 0,
        },
        background:{
            color:'#fafafa',
            // color:'transparent',
            padding:0,
            radius: 0,
        },
        content:{
            padding:0,
            paddingTop:0,
            paddingRight:20,
            paddingBottom:10,
            paddingLeft:20,
        }
    }    
}